import noop from "lodash/noop";

/**
 * Web stub for usePushNotificationDeepLinks.
 * Push notifications are native-only (iOS/Android).
 * On web, users receive notifications via browser APIs, not expo-notifications.
 */
const usePushNotificationDeepLinks = noop;

export default usePushNotificationDeepLinks;
